import React from "react";
import { TriggerBuilder } from "@redriver/cinnamon";
import { Button, Icon } from "semantic-ui-react";
import {
  exportDocumentAuditTrails,
  exportWorkCards,
  getDocumentAuditTrailCsvDownload,
} from "./actions";
import { useTranslation } from "react-i18next";
import { saveFile } from "features/../../../shared/modules/helpers";

const FILENAME = "DocumentAuditTrails.csv";

const ExportDocumentAuditTrails = ({
  filters,
  pageNumber,
  pageSize,
  ...props
}) => {
  const { t } = useTranslation("documentAuditTrails");
  return (
    <TriggerBuilder
      submitAction={exportDocumentAuditTrails}
      submitParams={{
        filters,
        pageSize,
        pageNumber,
      }}
      onSubmitted={(response) => saveFile(response, FILENAME)}
      renderTrigger={(fireTrigger, state) => (
        <Button
          primary
          {...props}
          onClick={fireTrigger}
          loading={state.submitting}
          disabled={state.submitting}
        >
          <Icon name="download" />
          {t("CSV")}
        </Button>
      )}
    />
  );
};

export default ExportDocumentAuditTrails;
